export enum IndustryType {
  FOODSERVICE = 'FOODSERVICE',
  RETAIL = 'RETAIL',
  INDUSTRIAL = 'INDUSTRIAL',
  NONFOOD = 'NONFOOD'
}
